module.exports = __webpack_public_path__ + "static/media/payroll.b1ba06c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/payroll.svg
// module id = 413
// module chunks = 0